// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'a61ef5fa1be4c53ae3899059e58e5be84648207f';
export const BUILD_NUMBER = '182';
export const BUILD_TIMESTAMP = '2026-07-01T05:49:11.479Z';
